<div class="foreign-currency">
    <h1 class="subtitle" id="generalTitle">
        {{ copyService.copies.foreign_currency_subtitle }}
        <vcl-additional-info id="vclAdditionInfoLeft" class="info-icon" [text]="copyService.copies.foreign_currency_additional_information_text" position="down-left" a11yLabelButton="ciiuCode" (click)="clickInfo()"></vcl-additional-info>
        <vcl-additional-info id="vclAdditionInfoRight" class="info-icon" [text]="copyService.copies.foreign_currency_additional_information_text" position="down-right" a11yLabelButton="ciiuCode" (click)="clickInfo()"></vcl-additional-info>
    </h1>
    <div class="content">
        <voxel-radio-button-group id="foreignList">
            <voxel-radio-button *ngFor="let foreignCurrency of listForeignCurrency" [checked]="foreignCurrency.checked" (radioButtonChange)="selectradioforeignCurrency($event, foreignCurrency)" [value]="foreignCurrency.elementId">
                {{foreignCurrency.label}}
            </voxel-radio-button>
        </voxel-radio-button-group>
    </div>
</div>
<app-controls id="foreignCurrencyBtns" [hasPrevious]="true" [nextLabel]="copyService.copies.foreign_currency_button"
    [nextDisabled]="stateButton" (next)="next()"></app-controls>
